import useAuth from "hooks/UseAuth"
import { Link, useHistory } from "react-router-dom"
import { FormEvent, useEffect, useState } from "react"

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"
import { ProfileImage } from "shared/components/organisms/ProfileImage/ProfileImage"
import { InputIconBox } from "shared/components/molecules/InputIconBox/InputIconBox"
import { toast } from "react-toastify"

import { HandleInputChange } from "./utils/HandleInputChange"
import { HandleEmailChange } from "./utils/HandleEmailChange"
import { HandlePasswordChange } from "./utils/HandlePasswordChange"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as MailIcon } from 'assets/icons/icon-mail.svg'
import { ReactComponent as LockIcon } from 'assets/icons/icon-locker.svg'

import { IWebProfileFormData } from "./interfaces"

import { Container, Content, Subheader, Section } from "./_webProfile"
import { NotificationModal } from "shared/components/organisms/NotificationModal/NotificationModal"

export const WebProfile = () => {
  const history = useHistory()
  const { user, updateUser } = useAuth()

  const [webProfileFormData, setWebProfileFormData] = useState({} as IWebProfileFormData)

  const [showModal, setShowModal] = useState(false)
  const [disableForm, setDisableForm] = useState(true)

  const HandleFormSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    try {
      if(webProfileFormData?.email){
        await HandleEmailChange(webProfileFormData)
      }

      if(webProfileFormData?.password && webProfileFormData?.old_password) {
        await HandlePasswordChange(webProfileFormData)
      }

      await updateUser()

      setShowModal(true)
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    if(!!webProfileFormData?.email || (!!webProfileFormData?.password && !!webProfileFormData?.old_password)) {
      disableForm && setDisableForm(false)
    } else {
      !disableForm && setDisableForm(true)
    }
  }, [webProfileFormData])

  return (
    <Container>
      <Header />
      <Sidebar />
      <Subheader>
        <Link to="/perfil" className="web-profile__subheader-button">
          <LeftArrow
            className="web-profile__subheader-icon"
          />
        </Link>
      </Subheader>

      <Content>
        <ProfileImage />

        <Section>
          <h1 className="web-profile__section__title">
            Alterar e-mail e senha
          </h1>

          <form
            onSubmit={HandleFormSubmit}
            className="web-profile__section__form"
          >
            <div
              className="web-profile__section__form-input-wrapper"
            >
              <label
                className="web-profile__section__form-label"
                htmlFor="webProfileEmail"
              >
                Email
              </label>
              <InputIconBox
                id="webProfileEmail"
                icon={<MailIcon/>}
                type="email"
                placeholder="Alterar e-mail"
                name="email"
                defaultValue={user?.email}
                onChange={(event) => HandleInputChange({
                  event, setFormData: setWebProfileFormData
                })}
              />
            </div>
            <div
              className="web-profile__section__form-input-wrapper"
            >
              <label
                className="web-profile__section__form-label"
                htmlFor="webProfilePassword"
              >
                Senha atual
              </label>
              <InputIconBox
                id="webProfilePassword"
                icon={<LockIcon/>}
                type="password"
                placeholder="Senha"
                name="old_password"
                onChange={(event) => HandleInputChange({
                  event, setFormData: setWebProfileFormData
                })}
              />
            </div>
            <div
              className="web-profile__section__form-input-wrapper"
            >
              <label
                className="web-profile__section__form-label"
                htmlFor="webProfileNewPassword"
              >
                Nova senha
              </label>
              <InputIconBox
                id="webProfileNewPassword"
                icon={<LockIcon/>}
                type="password"
                placeholder="Alterar senha"
                name="password"
                onChange={(event) => HandleInputChange({
                  event, setFormData: setWebProfileFormData
                })}
              />
            </div>
            <button
              type="submit"
              className="web-profile__section__form-button"
              disabled={disableForm}
            >
              Salvar alteração
            </button>
          </form>
        </ Section>
      </Content>
      {showModal && (
        <NotificationModal
          toggleModal={setShowModal}
          success
          callback={() => history.push("/perfil")}
        />
      )}
    </Container>
  )
}
